import { render, staticRenderFns } from "./reverse_button.vue?vue&type=template&id=1c5e9065&"
import script from "./reverse_button.vue?vue&type=script&lang=js&"
export * from "./reverse_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports